<template>
  <v-container fluid>
    <v-dialog v-model="loadingDatas" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center justify-center pa-8">
          <v-progress-circular indeterminate color="white" size="48" class="mb-4" />
          <span class="text-h6">Aguarde...</span>
          <small class="mt-2">Carregando datas disponíveis...</small>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingInscricao" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center justify-center pa-8">
          <v-progress-circular indeterminate color="white" size="48" class="mb-4" />
          <span class="text-h6">Aguarde...</span>
          <small class="mt-2">Realizando inscrição...</small>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card v-if="inscricao && inscricao.cabecalho" class="mx-auto my-5" max-width="700" outlined>
      <v-card-title class="headline">Dados da Inscrição</v-card-title>

      <v-card-text>
        <v-list dense>
          <v-list-item style="font-size: 1rem">
            <v-list-item-content>
              <p><strong>ID Inscrição:</strong> {{ inscricao.cabecalho.pkinscricao }}</p>
              <p><strong>NOME:</strong> {{ inscricao.cabecalho.nome }}</p>
              <p><strong>CPF:</strong> {{ inscricao.cabecalho.cpf | cpf }}</p>
              <p>
                <strong>Data da Inscrição:</strong>
                {{ inscricao.cabecalho.data_inscricao | formatarData }}
              </p>
              <p>
                <strong
                  >Tempo magistério:
                  <span v-if="inscricao.cabecalho.tempo_magisterio.ano > 0"
                    >{{ inscricao.cabecalho.tempo_magisterio.ano }} ano(s)</span
                  >
                  <span v-if="inscricao.cabecalho.tempo_magisterio.mes > 0"
                    >{{ inscricao.cabecalho.tempo_magisterio.mes }} mes(es)</span
                  >
                  <span v-if="inscricao.cabecalho.tempo_magisterio.dia > 0"
                    >{{ inscricao.cabecalho.tempo_magisterio.dia }} dia(s)</span
                  >
                </strong>
              </p>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-btn color="primary" @click="abrirDialogDatas" class="mb-3"> Selecionar Data de Evento </v-btn>
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-card-title>
              <span class="headline">Selecionar Data de Eventos</span>
            </v-card-title>
            <v-card-text>
              <p
                class="text-justify pa-2"
                style="border: solid #ddd 1.5px"
                v-for="item in datasevento"
                :key="item.pkdatadistribuicao"
                @click="selectedData(item)"
              >
                {{ item.pkdatadistribuicao }} - {{ item.descricao }}
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialog = false">Cancelar</v-btn>
              <v-btn color="primary" @click="incluirDataEvento">Incluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-divider class="my-3"></v-divider>

        <v-card-subtitle class="mb-2">Datas de Distribuição</v-card-subtitle>
        <v-card class="pa-2 text-justify" v-if="inscricao.datas.length == 0">
          No momento você não tem nenhuma data de distribuição selecionada. Sua inscrição esta invalida. clique no botão
          Selecionar Data de Evento para incluir uma data.
        </v-card>
        <v-list dense v-if="inscricao.datas.length > 0">
          <v-list-item
            style="font-size: 1rem; border: 5px solid #ddd"
            v-for="data in inscricao.datas"
            :key="data.pkdatadistribuicao"
          >
            <v-list-item-content>
              <p>
                <strong>ID: {{ data.pkdatadistribuicao }}</strong>
              </p>
              <p><strong>Descrição:</strong> {{ data.descricao }}</p>
              <p><strong>Data Distribuição:</strong> {{ data.data_distribuicao | formatarData }}</p>
              <p><strong>Data Encerramento:</strong> {{ data.data_encerramento | formatarData }}</p>
              <p><strong>Horário Início:</strong> {{ data.h_inicio }}</p>
              <p><strong>Local:</strong> {{ data.local }}</p>
              <hr />
              <v-btn color="error" small @click="excluirData(data)"> Desistir desta Data </v-btn>
              <v-card v-if="String(data.uppload_doc).trim().length > 0">
                <p><strong>Fazer Upload:</strong> {{ data.uppload_doc }}</p>
                <v-file-input
                  accept="application/pdf"
                  label="Enviar PDF"
                  prepend-icon="mdi-upload"
                  @change="uploadDocumento($event)"
                  outlined
                  dense
                ></v-file-input>
              </v-card>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card v-if="inscricao.cabecalho.docs" class="mt-5">
          <v-card class="pa-2 text-justify" v-if="lista_Uploads.length == 0">
            Verifique a necessidade de fazer uploads de documentos.
          </v-card>
          <div v-if="lista_Uploads.length > 0">
            <v-card-title class="headline">Documentos</v-card-title>
            <v-card-text> </v-card-text>
            <v-list v-if="lista_Uploads && lista_Uploads.length" dense>
              <v-list-item v-for="(upload, idx) in lista_Uploads" :key="idx">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon left color="primary">mdi-file-pdf</v-icon>
                    {{ upload }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon color="error" @click="deletarUpload(upload)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-card>
      </v-card-text>
    </v-card>
    <v-alert v-else type="info" class="mt-5">Nenhuma inscrição encontrada.</v-alert>
  </v-container>
</template>

<script>
import { Libs } from "@/libs/libs";
import filtros from "@/libs/filters";
import RemocaoServices from "@/services/rh/RemocaoServices";
import InscricaoRemocaoServices from "@/services/remocao/InscricaoRemocaoServices";
//import { mapGetters } from "vuex";

export default {
  name: "DadosInscricao",
  data: () => ({
    dialog: false,
    datasDisponiveis: [],
    loadingDatas: false,
    loadingInscricao: false,
  }),
  components: {},
  filters: {
    ...filtros,
    cpf(value) {
      if (!value) return "";
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    formatarData(value) {
      if (!value) return "-";
      // Corrige diferença de dia ao converter datas (trata como local)
      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        // yyyy-mm-dd sem hora: cria data local
        const [year, month, day] = value.split("-").map(Number);
        const d = new Date(year, month - 1, day);
        return d.toLocaleDateString("pt-BR");
      }
      // Para ISO ou outros formatos
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString("pt-BR");
    },
  },
  computed: {
    idInscricao() {
      return this.inscricao.cabecalho.pkinscricao;
    },
    processo() {
      const lista = this.$store.getters["config/getProcessos"];
      return lista.find((p) => p.id == 1);
    },
    inscricao() {
      return this.$store.getters["remocao/getInscricaoUsuario"];
    },
    datasevento() {
      return this.$store.getters["remocao/datasRemocao"];
    },
    lista_Uploads() {
      return this.$store.getters["remocao/getListaUploadsInscricao"];
    },
  },
  methods: {
    async deletarUpload(nomeArquivo) {
      try {
        this.loadingInscricao = true;
        // aqui precisa informar nome arquivo, ano e cpf
        const cpf = this.inscricao.cabecalho.cpf;
        const ano = this.processo.ano;

        await RemocaoServices.deletarUploadInscricao(nomeArquivo, cpf, ano);
        await this.listarUploads();
      } catch (e) {
        this.$emit("upload-erro", e);
      } finally {
        this.loadingInscricao = false;
      }
    },
    async abrirDialogDatas() {
      this.loadingDatas = true;
      try {
        // Simula requisição, troque por chamada real se necessário
        this.datasDisponiveis = this.$store.getters["remocao/datasRemocao"] || [];
        // Se quiser garantir atualização, pode usar await RemocaoServices.bootstrapListarDatasDistribuicao(ano)
      } finally {
        this.loadingDatas = false;
        this.dialog = true;
      }
    },
    async reloadInscricao() {
      await InscricaoRemocaoServices.dadosInscricaoUsuario({
        pkpessoa: this.inscricao.cabecalho.pkpessoa,
        ano: this.processo.ano,
      });
    },
    async selectedData(item) {
      this.loadingInscricao = true;
      try {
        const paramSalvar = {
          fkinscricao: this.inscricao.cabecalho.pkinscricao,
          fkdatainscricao: item.pkdatadistribuicao,
        };
        await RemocaoServices.inscreverEmData({ data: [paramSalvar] });
        await this.reloadInscricao();
      } finally {
        this.loadingInscricao = false;
        this.dialog = false;
      }
    },
    incluirDataEvento() {
      this.dialog = false;
    },
    async excluirData(data) {
      try {
        this.loadingInscricao = true;
        await RemocaoServices.desistirData(data.id_item);
        await this.reloadInscricao();
      } finally {
        this.loadingInscricao = false;
      }
    },

    async listarUploads() {
      const cpf = this.inscricao?.cabecalho?.cpf;
      const ano = this.processo?.ano;
      try {
        this.loadingInscricao = true;
        await RemocaoServices.listarUploadsInscricao(ano, cpf);
      } catch (e) {
        this.$store.commit("remocao/setListaUploadsInscricao", []);
      } finally {
        this.loadingInscricao = false;
      }
    },

    async uploadDocumento($event) {
      // docs: texto do campo, $event: arquivo
      const cpf = this.inscricao.cabecalho.cpf;
      const ano = this.processo.ano;
      const file = $event;
      if (!file) return;
      // Limpa nome do arquivo
      const nomeLimpo = Libs.limparNomeArquivo(file.name);
      const novoFile = new File([file], nomeLimpo, { type: file.type });
      const formData = new FormData();
      formData.append("documentos", novoFile);
      formData.append("cpf", cpf);
      formData.append("ano", ano);

      try {
        this.loadingInscricao = true;
        const data = await RemocaoServices.uploadDocumentoInscricao(formData, cpf, ano);
        console.log("retorno de upload......", data);
        this.$emit("upload-sucesso");
      } catch (e) {
        this.$emit("upload-erro", e);
      } finally {
        this.loadingInscricao = false;
      }
    },
  },
};
</script>
